import React, { useEffect, useState } from "react";
import PropertyCard from "../../../../components/PropertyCard";
import PropertyRadarBanner from "../PropertyRadarCTA/PropertyRadarBanner";
import PropertyRadarModal from "../PropertyRadarCTA/PropertyRadarModal";
import {
  ListContainer,
  Wrapper,
  FadeIn,
  EmptyListMessage,
  PropertiesNotFountTitle,
  PropertiesNotFountImage,
  EmptyAreaContainer,
  EmptyAreaIcon,
  EmptyAreaContent,
  EmptyAreaTitle,
  EmptyAreaMessage,
  EmptyAreaActions,
  ReloadButton,
  ErrorStateContainer,
  ErrorStateTitle,
  ErrorStateMessage,
} from "./style";
import propertyNotFoundImg from "../../../../assets/components/PropertiesCardList/no-properties-found.png";
import { Property } from "../../../../global/types";
import { useAuth } from "../../../../hooks/auth";
import api from "../../../../services/api";
import {
  loadMapView,
  saveReturnContext,
} from "../../utils/mapViewStorage";

interface IProps {
  propertiesList: Property[];
  isMapActive: boolean;
  isLoading?: boolean;
  searchParams: string;
  error?: string | null;
  neighborhoodFilter?: string | null;
  isEmptyArea?: boolean;
  originalCity?: string | null;
  onReloadPage?: () => void;
  onCloseMessage?: () => void;
}

interface IFavorites {
  id: number;
  favorite_id: number;
}

export default function PropertyCardList({
  propertiesList = [],
  isMapActive,
  isLoading = false,
  searchParams,
  error = null,
  neighborhoodFilter = null,
  isEmptyArea = false,
  originalCity = null,
  onReloadPage = () => { },
  onCloseMessage = () => { },
}: IProps) {
  const { user, access_token } = useAuth();
  const [favorites, setFavorites] = useState<IFavorites[]>([]);
  const [loadingFavorites, setLoadingFavorites] = useState(false);
  const [radarModalOpen, setRadarModalOpen] = useState(false);

  useEffect(() => {
    async function getFavorites() {
      setLoadingFavorites(true);
      try {
        api.defaults.headers.authorization = `Bearer ${access_token}`;
        await api.get("/api/client/tenant/favorites").then((responseApi) => {
          setFavorites(responseApi.data.data);
        });
      } catch (err) {
        console.log(err);
      }
      setLoadingFavorites(false);
    }
    if (!!user) {
      getFavorites();
    }
  }, [access_token, user]);

  const handleNavigateToProperty = () => {
    const currentView = loadMapView();
    if (currentView) {
      saveReturnContext(currentView);
    }
  };

  if (error) {
    return (
      <ListContainer data-testid="property-card-list">
        <Wrapper $isMapActive={isMapActive} $isListEmpty={true}>
          <ErrorStateContainer>
            <ErrorStateTitle>Erro ao carregar imóveis</ErrorStateTitle>
            <ErrorStateMessage>{error}</ErrorStateMessage>
            <ReloadButton onClick={onReloadPage}>Tentar novamente</ReloadButton>
          </ErrorStateContainer>
        </Wrapper>
      </ListContainer>
    );
  }

  return (
    <ListContainer data-testid="property-card-list">
      <Wrapper $isMapActive={isMapActive} $isListEmpty={propertiesList.length === 0}>
        {propertiesList.length > 0 &&
          !loadingFavorites &&
          propertiesList.map((property: Property) => (
            <FadeIn key={property.id}>
              <PropertyCard
                property={property}
                isInitiallyFavorite={
                  !!favorites.find((fav: IFavorites) => fav.id === property.id)
                }
                searchParams={searchParams}
                onNavigate={handleNavigateToProperty}
              />
            </FadeIn>
          ))}

        {propertiesList.length === 0 && !loadingFavorites && !isLoading && (
          <>
            {isEmptyArea && originalCity && (
              <EmptyAreaContainer>
                <EmptyAreaContent>
                  <EmptyAreaIcon>!</EmptyAreaIcon>
                  <div>
                    <EmptyAreaTitle>
                      Fora da área de {originalCity}
                    </EmptyAreaTitle>
                    <EmptyAreaMessage>
                      Mova o mapa ou recarregue a página
                    </EmptyAreaMessage>
                  </div>
                </EmptyAreaContent>
                <EmptyAreaActions>
                  <ReloadButton onClick={onReloadPage}>
                    Recarregar
                  </ReloadButton>
                </EmptyAreaActions>
              </EmptyAreaContainer>
            )}

            <EmptyListMessage>
              <PropertiesNotFountTitle>
                Nenhum imóvel encontrado
                {neighborhoodFilter ? ` em ${neighborhoodFilter}` : ""}.
              </PropertiesNotFountTitle>
              <PropertiesNotFountImage src={propertyNotFoundImg} alt="Imagem de imóvel não encontrado" />
            </EmptyListMessage>
          </>
        )}

        {loadingFavorites && <p>Carregando...</p>}

        {!loadingFavorites && (
          <PropertyRadarBanner onOpenModal={() => setRadarModalOpen(true)} />
        )}

        <PropertyRadarModal
          open={radarModalOpen}
          onClose={() => setRadarModalOpen(false)}
          searchParams={searchParams}
          accessToken={access_token}
          user={user}
        />
      </Wrapper>
    </ListContainer>
  );
}